import * as R from 'remeda';
import { useIntl } from 'react-intl';
import { Typography, useTheme } from '@rossum/ui/material';
import { BarChart } from '@rossum/ui/x-charts-pro';
import { formatNumberToLocale } from '../../../../../../lib/helpers';
import { getBlockerTranslation } from '../../utils';
import { ChartWrapper } from './ChartWrapper';
import { CustomTooltip } from './CustomTooltip';
import { getChartColors } from './styles';
import { getCommonYAxisProps } from './utils';

type AutomationBlockersChartProps = {
  totalBlockers: {
    values: number[];
    labels: string[];
  };
};

export const AutomationBlockersChart = ({
  totalBlockers,
}: AutomationBlockersChartProps) => {
  const theme = useTheme();
  const intl = useIntl();

  const { primary } = getChartColors(theme);
  return (
    <ChartWrapper elevation={0}>
      <Typography variant="h5" sx={{ span: { color: 'text.secondary' } }}>
        {formatNumberToLocale(R.sum(totalBlockers.values))}{' '}
        <span>
          {intl.formatMessage({
            id: 'containers.settings.queues.queue.automation.charts.automationBlockers.title',
          })}
        </span>
      </Typography>
      <BarChart
        layout="horizontal"
        series={[
          {
            data: totalBlockers.values,
            color: primary,
            valueFormatter: val => (val ? formatNumberToLocale(val) : null),
          },
        ]}
        yAxis={[
          {
            ...getCommonYAxisProps(theme.palette.text.secondary),
            tickLabelPlacement: 'middle',
            position: 'left',
            data: totalBlockers.labels,
            scaleType: 'band',
            valueFormatter: (value: string) => {
              return getBlockerTranslation({ intl, key: value });
            },
            tickLabelInterval: () => true,
            width: 100,
          },
        ]}
        xAxis={[
          {
            tickLabelStyle: {
              fill: theme.palette.text.secondary,
            },
            tickLabelPlacement: 'middle',
            tickLabelInterval: (_, index) => index !== 0,
            tickNumber: 4,
            disableLine: true,
            disableTicks: true,
            valueFormatter: (val: (typeof totalBlockers.values)[number]) =>
              formatNumberToLocale(val),
          },
        ]}
        grid={{ vertical: true }}
        borderRadius={4}
        margin={{ left: 0, right: 0 }}
        slotProps={{
          legend: {
            position: { vertical: 'bottom', horizontal: 'start' },
          },
        }}
        slots={{
          tooltip: CustomTooltip,
        }}
        sx={{ overflow: 'visible' }}
      />
    </ChartWrapper>
  );
};
